module.exports = __webpack_public_path__ + "static/img/p2.5e750519.png";